import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { useMemo } from 'react';

import Image from '~components/Image';
import { BANNERS } from '~constant/banner';
import useMedia from '~hooks/useMedia';
import { Banner } from '~types/ranking';
import { shuffle } from '~utils/common/shuffle';

import { SLICK_SETTING } from './constants';
import * as S from './style';

function SideBanner() {
  const { isMobile } = useMedia();

  const shuffleBanners = useMemo(() => shuffle<Banner[]>(BANNERS), []);

  return (
    <S.Wrapper {...SLICK_SETTING} dotsClass='side-slider'>
      {shuffleBanners.map((banner) => {
        return (
          <S.SideBannerWrapper
            key={`banner_slider_${banner.eventId}`}
            data-attribute-id='home__banner__click'
            data-banner-type={banner.eventId}
            data-banner-location='right'
            background={banner.color}
            target='_blank'
            href={banner.landingUrl}>
            <S.Title>{banner.title}</S.Title>
            <S.SubTitle>{isMobile ? banner.side_mobile : banner.side_web}</S.SubTitle>
            <Image src={banner.image} alt={banner.title} width={420} />
          </S.SideBannerWrapper>
        );
      })}
    </S.Wrapper>
  );
}

export default SideBanner;
